import ShoppingLinks from 'components/Header/BeautyPreferences/ShoppingLinks/ShoppingLinks';
import { withShoppingLinksProps } from 'viewModel/header/beautyPreferences/shoppingLinks/withShoppingLinksProps';

const ConnectedShoppingLinks = withShoppingLinksProps(ShoppingLinks);

export default ConnectedShoppingLinks;
